
/**
 * A class for a guranteed root node.
 */
export class GuranteedRoot{
    isRoot: boolean;
    constructor(){
        this.isRoot = true;
    }
}